module.exports = __webpack_public_path__ + "img/ic_charge_location.75cf31c2.png";